import client from './axiosConfig';

export const getMRR = (params) => {
    const config = {
        url: `/inventory/mrr/`,
        method: "GET",
        params
    }

    const response = client(config);
    return response;
};

export const getMRRMaterial = (mrrId, params) => {
    const config = {
        url: `/inventory/mrr/${mrrId}/materials/`,
        method: "GET",
        params
    }

    const response = client(config);
    return response;
};

export const getAvailableMaterialsByWarehouseAndMRR = (
  mrr_id,
  warehouse_id
) => {
  const config = {
    url: `/inventory/mrr/${mrr_id}/materials-with-available/`,
    method: "GET",
    params: {
      warehouse_id,
    },
  };
  const response = client(config);
  return response;
};